



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IFootbowlAction } from './types';

export const actionValidator = (obj: any) =>
  !obj || (
    obj.name !== undefined && obj.description !== undefined &&
    ['home', 'visitor', 'none'].includes(obj.team.toLowerCase())
  );

@Component({})
export default class FootbowlAction extends Vue {
  @Prop({ required: true, type: Boolean })
  public homeOnLeft!: boolean;

  @Prop({ required: false, type: Object, validator: actionValidator })
  public action?: IFootbowlAction;

  @Prop({ required: false, type: Number })
  public gain?: number;

  get actionVideoSources() {
    if (!this.action || !this.action.name) {
      return null;
    }

    const name = this.action.name.toLowerCase();
    const side = this.action.team.toLowerCase() === 'home'
      ? (this.homeOnLeft ? 'left' : 'right')
      : (this.homeOnLeft ? 'right' : 'left');

    const webm = this.tryLoadAction(`${name}_${side}.webm`) ||
      this.tryLoadAction(`${name}.webm`);
    const mp4 = this.tryLoadAction(`${name}_${side}.mp4`) ||
      this.tryLoadAction(`${name}.mp4`);

    const videos = [webm, mp4].filter((src) => !!src);
    return videos.length ? videos : null;
  }

  get actionImage() {
    if (!this.action || !this.action.name) {
      return null;
    }

    const name = this.action.name.toLowerCase();
    const side = this.action.team.toLowerCase() === 'home'
      ? (this.homeOnLeft ? 'left' : 'right')
      : (this.homeOnLeft ? 'right' : 'left');


    return (
      this.tryLoadAction(`${name}_${side}.jpg`) ||
      this.tryLoadAction(`${name}.jpg`)
    );
  }

  get displayGain() {
    return false;
  }

  private tryLoadAction(name: string) {
    try {
      return require(`@/assets/footbowl/actions/${name}`) || null;
    } catch (e) {
      return null;
    }
  }
}

